import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable({
	providedIn: 'root'
})
export class UserHttpService {

	constructor(private http: HttpClient,
		private configService: ConfigService) {

	}

	public validateToken(): Observable<any> {

		return this.http.get<any>(`${this.configService.accountEndpoint}/user/self`);
	}

	public updateUserProfile(profile: any): Observable<any> {

		return this.http.patch<any>(`${this.configService.accountEndpoint}/user/self`, profile);
	}

	public updateUserPassword(params: any): Observable<any> {

		return this.http.patch<any>(`${this.configService.accountEndpoint}/user/password`, params);
	}

	public updateUserProfileImage(params: any): Observable<any> {

		return this.http.post<any>(`${this.configService.accountEndpoint}/user/photo`, params);
	}

	public getAddOnQuoteForUser(addOn: string): Observable<any> {

		return this.http.get<any>(`${this.configService.accountEndpoint}/user/add-on/quote?add_on=${addOn}`);
	}

	public activateAddOn(addOn: string): Observable<any> {

		return this.http.post<any>(`${this.configService.accountEndpoint}/user/subscription/add-on/`, { "add_on": addOn });
	}

	public deactivateAddOn(addOn: string): Observable<any> {

		return this.http.delete(`${this.configService.accountEndpoint}/user/subscription/add-on/${addOn}`);
	}
}